// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoSt4 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.st_4";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoSt4 {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Nosaltres i els nostres socis fem el següent tractament de dades",
                "cs": "My a naši partneři provádíme následující zpracování dat",
                "da": "Vi og vores partnere behandler følgende data",
                "de": "Wir und unsere Partner verarbeiten die folgenden Daten",
                "el": "Εμείς και οι συνεργάτες μας επεξεργαζόμαστε τα ακόλουθα δεδομένα",
                "en": "We and our partners do the following data processing",
                "es": "Nosotros y nuestros socios hacemos el siguiente tratamiento de datos",
                "eu": "Gure eta gure bazkideen datuak prozesatzen ditugu",
                "fi": "Me ja kumppanimme käsittelemme seuraavia tietoja",
                "fr": "Nous et nos partenaires effectuons le traitement des données suivant",
                "gl": "Nós e os nosos socios facemos o seguinte tratamento de datos",
                "hi": "हम और हमारे साथी निम्नलिखित डेटा प्रोसेस करते हैं",
                "hu": "Mi és partnereink az alábbi adatfeldolgozást végezzük",
                "it": "Noi e i nostri partner effettuiamo il seguente trattamento dei dati",
                "nl": "Wij en onze partners verwerken de volgende gegevens",
                "no": "Vi og våre partnere behandler følgende data",
                "pl": "My i nasi partnerzy przetwarzamy następujące dane",
                "pt": "Nós e os nossos parceiros fazemos o seguinte tratamento de dados",
                "ro": "Noi și partenerii noștri efectuăm următoarea prelucrare a datelor",
                "ru": "Мы и наши партнеры обрабатываем следующие данные",
                "sv": "Vi och våra partners behandlar följande data",
                "tr": "Biz ve ortaklarımız aşağıdaki veri işlemi yaparız"
            },
            "defecto": "We and our partners do the following data processing"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
